const init = () => {
  if (!window.gsap) return;
  if (!window.ScrollTrigger) return;

  const servicios = document.querySelectorAll(".servicios-anim");
  if (!servicios.length) return;

  // Solo en versiones NO móvil...
  if (window.innerWidth < 768) return;

  // Refrescamos al escalar...
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768) {
      init();
    }
  });

  servicios.forEach((servicio) => {
    let duration = 0.4;

    const trigger =
      servicio.closest(".servicios-anim-trigger") || servicio.parentElement;
    if (!trigger) return;

    const elementos = servicio.querySelectorAll(".servicios-anim-item");
    if (!elementos.length) return;

    const icons = trigger.querySelectorAll(".servicios-icons-in svg");

    const tl = window.gsap.timeline({
      scrollTrigger: {
        trigger,
        start: "top center",
        end: "+=400%",
        scrub: true,
        markers: false,
      },
    });

    window.ScrollTrigger.create({
      trigger,
      start: "top top",
      end: "+=400%",
      pin: true,
      pinSpacing: true,
    });

    window.gsap.set(elementos[0], { position: "relative", zIndex: 1 });
    window.gsap.set(Array.from(elementos).slice(1), {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 2,
      opacity: 0,
    });

    window.gsap.set(icons, { opacity: 0 });

    window.gsap.set(".servicios-anim-sb", { "--sb-width": "0%", opacity: 0 });

    const firstH2 = elementos[0].querySelector("h2");
    const firstText = elementos[0].querySelector(".text-content");
    const containerRect = servicio.getBoundingClientRect();
    const baseH2Top = firstH2
      ? firstH2.getBoundingClientRect().top - containerRect.top
      : 0;
    const baseH2Left = firstH2
      ? firstH2.getBoundingClientRect().left - containerRect.left
      : 0;
    const baseTextTop = firstText
      ? firstText.getBoundingClientRect().top - containerRect.top
      : 0;
    const baseTextLeft = firstText
      ? firstText.getBoundingClientRect().left - containerRect.left
      : 0;

    for (let i = 1; i < elementos.length; i++) {
      const h2 = elementos[i].querySelector("h2");
      const text = elementos[i].querySelector(".text-content");

      if (h2) window.gsap.set(h2, { position: "absolute", top: baseH2Top, left: baseH2Left });

      if (text)
        window.gsap.set(text, { position: "absolute", top: baseTextTop, left: baseTextLeft });
    }

    tl.to(icons, { opacity: .3, duration: duration, ease: "power2.out" });
    tl.to(icons[0], { opacity: 1, duration: duration, ease: "power2.out" }, "<");
    tl.to(".servicios-anim-sb", { "--sb-width": ( 1 * 100 / elementos.length ) + "%", duration: duration, ease: "power2.out", opacity: 1 }, "<");

    tl.from(elementos[0].querySelectorAll("h2, .text-content"), {
      opacity: 0,
      y: 20,
      duration: duration,
      ease: "power2.out",
    }, "<");

    for (let i = 1; i < elementos.length; i++) {

      tl.to(elementos[i], { opacity: 1, duration: duration, ease: "power2.out" });

      tl.from(
        elementos[i].querySelectorAll("h2, .text-content"),
        { opacity: 0, duration: duration, ease: "power2.out" },
        "<"
      );

      tl.to(icons[i], { opacity: 1, duration: duration, ease: "power2.out" }, "<");

      tl.to(
        elementos[i - 1],
        { opacity: 0, duration: duration, ease: "power2.out" },
        "<"
      );

      tl.to(
        ".servicios-anim-sb",
        {
          "--sb-width": ((i + 1) * 100) / elementos.length + "%",
          duration: duration,
          ease: "power2.out",
        },
        "<",
      );
    }
  });
};

export { init };
